import config from '../config';

/**
 * Génère l'URL de l'API pour une icône avec la couleur et la taille spécifiées
 * Format: /api/icons/style_name_width_height_color.png
 * @param {Object} libraryIcon - Objet contenant name, path, style
 * @param {string} color - Couleur hex (avec ou sans #)
 * @param {number} size - Taille en pixels (défaut: 20)
 * @returns {string} URL de l'icône
 */
export const getIconApiUrl = (libraryIcon, color = '#000000', size = 20) => {
    if (!libraryIcon || !libraryIcon.name || !libraryIcon.style) {
        return '';
    }

    return config.getIconUrl(libraryIcon.style, libraryIcon.name, size, color);
};
